import { get } from 'lodash';

import { ASSET_TYPE, FIELD_PATHS, FIELD_VALUES } from '@funnels/constants';
import { AnyFormValues, Asset, Liability, PropertyAsset } from '@funnels/types';
import { getAssetPurpose } from '@funnels/utils';

// isFastRefi flag will only be existed when all properties are (refinance and other property only but at least one refi property) and non-construction property
export const getShouldClearFastRefi = (formValues: AnyFormValues) => {
  const assets: Asset[] = get(formValues, FIELD_PATHS.ASSETS(), []);
  const liabilities: Liability[] = get(formValues, FIELD_PATHS.LIABILITIES());
  const properties = assets.filter((asset) => asset.type === ASSET_TYPE.PROPERTY) as PropertyAsset[];
  let atLeastOneRefiProperty = false;
  let hasConstructionProperty = false;
  let hasNPOrSecurityProperties = false;

  properties.forEach((property) => {
    const propertyType = getAssetPurpose({ assets: [property], liabilities }, 0);
    switch (propertyType) {
      case FIELD_VALUES.OTHER:
        return;
      case FIELD_VALUES.REFINANCE:
        atLeastOneRefiProperty = true;
        break;
      case FIELD_VALUES.SECURITY_PROPERTY:
      case FIELD_VALUES.NEW_PURCHASE:
        hasNPOrSecurityProperties = true;
    }
    if (property.isConstruction) {
      hasConstructionProperty = true;
    }
  });
  return !(atLeastOneRefiProperty && !hasNPOrSecurityProperties && !hasConstructionProperty);
};
